import { useProgress } from '../lib/playerHooks'

type ProgressBarProps = {
  updateInterval: number;
  showSeconds?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ showSeconds = false, updateInterval }) => {
  const { milliseconds, phase } = useProgress(updateInterval || 250)

  return (
    <div className="progress-bar" style={{ width: `${Math.round(phase * 100)}%` }}>
      {showSeconds && <p>{`, ${Math.floor(milliseconds / 1000)}.${Math.floor((milliseconds % 1000) / 100)}`}</p>}
    </div>
  )
}
